import React, { useEffect, useState } from "react";
import { AuthenticationResult, EventType, PublicClientApplication } from "@azure/msal-browser";
import { MsalAuthenticationTemplate, MsalProvider } from "@azure/msal-react";
import { authType, buildConfig } from "../../aadConfig";
import { useSecuritySetting } from "../../store/store";
import LoadingScreen from "../LoadingScreen/LoadingScreen";

interface ContainerProps {
    children: React.ReactNode | React.ReactNode[];
    scopes: Array<string>;
}

export default function AADWrapper({ children, scopes }: Readonly<ContainerProps>) {
    const securitySettings = useSecuritySetting();
    const MSALInstance = useSecuritySetting(state => state.msalInstance);
    const [initialized, setInitialized] = useState(false);


    const instance = new PublicClientApplication(buildConfig(securitySettings));

    instance.addEventCallback((message) => {
        if (message.eventType == EventType.LOGIN_SUCCESS && message.payload) {
            instance.setActiveAccount((message.payload as AuthenticationResult).account);
            console.log("Active account set - ", (message.payload as AuthenticationResult).account);
        }
    });

    useEffect(() => {
        async function init() {
            if (initialized) return;
            await instance.initialize();
            securitySettings.setMsalInstance(instance);
            setInitialized(true);
            console.log("AADWrapper initialized");
        }
        init();
    }, []);

    if (MSALInstance === null || !initialized) {
        return <LoadingScreen text="Loading Microsoft AD internals..." />;
    }
    console.log("Starting AAD MSAL with scopes: ", scopes);
    return (
        <MsalProvider instance={MSALInstance}>
            <MsalAuthenticationTemplate
                interactionType={authType}
                authenticationRequest={{ scopes: scopes }}
            >
                {children}
            </MsalAuthenticationTemplate>
        </MsalProvider>
    );
}
